import { Button } from '@material-ui/core'
import { motion } from 'framer-motion'
import React from 'react'
import {
  animationAppTransitions,
  animationAppVariants
} from '../../component/Helpers/pageAnimation'
import { useEditMode } from '../../providers/EditMode'

const ConfigPage = (): JSX.Element => {
  const { editMode, updateEditMode } = useEditMode()

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={animationAppVariants}
      transition={animationAppTransitions}
      style={{ minHeight: '100vh', padding: 10 }}
    >
      <Button
        onClick={() => updateEditMode(!editMode)}
        variant="contained"
        color="primary"
      >
        {!editMode ? 'Ativar' : 'Desativar'} modo de Edição
      </Button>
    </motion.div>
  )
}

export default ConfigPage
